(() => {
  const setScheduleState = (recipientForm) => {
    const checkbox = recipientForm.querySelector('[id^="Recipient-Checkbox-"]');
    const sendOn = recipientForm.querySelector('[data-recipient-send-on]');
    const timezoneOffset = recipientForm.querySelector('[data-recipient-timezone-offset]');

    if (!checkbox || !sendOn || !timezoneOffset) return;

    const latest = new Date();
    latest.setDate(latest.getDate() + 90);
    const localDateValue = new Date(latest.getTime() - latest.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
    sendOn.max = localDateValue;

    const update = () => {
      const isScheduled = checkbox.checked && sendOn.value !== '';
      timezoneOffset.disabled = !isScheduled;
      timezoneOffset.value = isScheduled ? String(new Date().getTimezoneOffset()) : '';
    };

    checkbox.addEventListener('change', () => {
      if (!checkbox.checked) sendOn.value = '';
      update();
    });
    sendOn.addEventListener('change', update);
    update();
  };

  document.querySelectorAll('.sf-recipient-form').forEach(setScheduleState);
})();
